import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import { authPromiseMiddleware, authMiddleware } from './middleware.js';
import rootReducer from '../reducers'

const configureStore = preloadedState => createStore(
  rootReducer,
  preloadedState,
  applyMiddleware(thunk, authPromiseMiddleware, authMiddleware)//, api)
)

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js